import HistoricalRiskDashboardFilter from './HistoricalRiskDashboardFilter';
export { HistoricalRiskDashboardFilter };
export default HistoricalRiskDashboardFilter;
